<template>
    <div v-show="visible">
        <el-dialog title="修改接收者"
            element-loading-background = "rgba(255, 255,255,0.7)"
            v-loading="loading" 
            :close-on-click-modal="false" :visible.sync="visible" :before-close="dialogClose" width="350px">    
            <el-form ref="form" :model="form" label-width="100px">
                <el-form-item prop="showUserRoster" label="下单后接收者">
                        <el-button @click="getMoreUser()">{{form.noticeUserRosterLabel}}</el-button>
                    </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取 消</el-button>
                <el-button type="primary" @click="save()">确 定</el-button>
            </span>    
        </el-dialog>
        <!-- 人员弹出框多人 -->
        <div v-if="userTransferMoreVisible">
            <userTransferMore ref="userTransferMore"></userTransferMore>
        </div>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import userTransferMore from '../../sys/user/UserTransfer.vue';

    export default {
        data(){
            return{
                visible: false,
                userTransferMoreVisible:false,
                form:{
                    deptId: "",
                    ids: "",
                    noticeUserRoster: [],
                    noticeUserRosterLabel: "请选择",
                },
                loading:false,
            }
        },
        components: {
            userTransferMore
        },
        created:function () {
        },
        methods:{
            init(deptId, ids){
                this.visible = true;
                this.form.deptId = deptId;
                this.form.ids = ids;
                this.form.noticeUserRosterLabel = "请选择";
                this.form.noticeUserRoster = [];
                console.log(deptId,ids);
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            getMoreUser(){
                this.userTransferMoreVisible=true;
                this.$nextTick(() => {
                    // 教职
                    this.$refs['userTransferMore'].init(2,this.form.noticeUserRoster,2,this.form.deptId);
                })
            },
            setUser(data,name){ 
                if(data.length == 0){
                    this.form.noticeUserRosterLabel="请选择";
                }else{
                    this.form.noticeUserRosterLabel=data.length+"人";
                }
                this.form.noticeUserRoster=data;
            },
            // 保存
            save(){
                let url= this.commodityBatchUpdateUrl;
                let data = {
                    ids: this.form.ids,
                    userIds: this.form.noticeUserRoster.join(','),
                };
                // console.log(JSON.stringify(data));
                // return;
                
                this.loading = true;
                this.apiPost(url, data).then((res) => {
                    if(res.status === 200){
                        this.$commonFn.showTip(res.message,1);
                        this.visible=false;
                        this.$parent.getData();
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                    this.loading=false;
                }, (err) => {
                    console.log(err);
                    this.loading=false;
                });
            }
        },
        mixins: [http]
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/shop/wares/SetNoticeUsers.vue